'use strict';

var _ = require('lodash');
var SortCustomizationController = function SortCustomizationController($scope, SortColumnOptions, SortCriteriaFactory) {
  $scope.sortCriteriaMeta = [{
    label: 'Sort By',
    index: 0
  }, {
    label: 'Then By',
    index: 1
  }, {
    label: 'Then By',
    index: 2
  }];
  $scope.columns = $scope.settings.columns;
  $scope.sortOptions = [];
  $scope.sortOptionsIdx = 0;
  $scope.sortCriteria = new SortCriteriaFactory();
  $scope._lastSortCriteria = new SortCriteriaFactory();
  $scope.saveMode = {
    isDefault: false
  };
  $scope.isSortCustomizationShown = false;
  $scope.updateSortCriteria = function (sortCriteria) {
    $scope.resetMultipleSorting();
    sortCriteria.getActiveSortColumns().forEach(function (column) {
      $scope.sortCriteria.add(column);
    });
    $scope.initializeSortOptions();
    $scope.adjustSortOptions();
  };
  $scope.resetMultipleSorting = function () {
    $scope.initializeSortOptions();
    $scope.sortCriteria.reset();
  };
  $scope.isDefaultSortCriteria = function () {
    return $scope.sortCriteria.hashCode() === $scope.settings.defaultSortCriteria.hashCode();
  };
  $scope.resetIfDefaultSortCriteria = function () {
    if ($scope.isDefaultSortCriteria()) {
      $scope.initializeSortOptions();
      $scope.adjustSortOptions();
      $scope.sortCriteria.getSortColumns().forEach(function (sortColumn) {
        sortColumn.reset();
      });
    }
  };
  $scope.resetSortCriteriaTo = function (sortCriteria) {
    $scope.sortCriteria = sortCriteria.clone();
    $scope.initializeSortOptions();
    $scope.adjustSortOptions();
    $scope.$broadcast('sortCustomization:resetSortColumns');
  };
  $scope.okButtonDisabled = function () {
    var sortColumns = _.compact(_.map($scope.sortCriteria.getSortColumns(), 'field'));
    var uniqueSortColumns = _.uniq(sortColumns);
    return sortColumns.length !== uniqueSortColumns.length;
  };
  $scope.dismissErrorMessage = function () {
    $scope.showSortError = false;
  };
  function findServerSortingDisabledColumns(columns) {
    return _.filter(columns, ['serverSortingAvailable', false]);
  }
  function getColumnsFromGroupColumns(columns) {
    return [].concat.apply([], _.chain(columns).filter(function (o) {
      return o.groupId;
    }).map('columns').value());
  }
  function getTitleFromNonSortableSelectedField(noServerSideColumns, selectedFieldsWithDisabledServerSort) {
    return _.chain(noServerSideColumns).filter(function (o) {
      return selectedFieldsWithDisabledServerSort.indexOf(o.field) >= 0;
    }).map('title').value().join(', ');
  }
  function isServerSortingAvailableForAllColumns() {
    var selectedFields = _.filter($scope.sortCriteria.columns, function (o) {
      return o.field.length;
    });
    var nonSortableColumns = findServerSortingDisabledColumns($scope.columns);
    var nonSortableGroupColumns = findServerSortingDisabledColumns(getColumnsFromGroupColumns($scope.columns));
    var noServerSideColumns = nonSortableColumns.concat(nonSortableGroupColumns);
    var selectedFieldsWithDisabledServerSort = _.intersection(_.map(selectedFields, 'field'), _.map(noServerSideColumns, 'field'));
    $scope.sortErrorFields = getTitleFromNonSortableSelectedField(noServerSideColumns, selectedFieldsWithDisabledServerSort);
    return selectedFieldsWithDisabledServerSort.length === 0;
  }
  $scope.saveSort = function ($event) {
    if ($scope.saveMode.isDefault) {
      if (isServerSortingAvailableForAllColumns()) {
        $scope.applyChangesCallback({
          sort: $scope.sortCriteria
        });
        $scope.saveMode.isDefault = false;
        $scope.showSortError = false;
      } else {
        $scope.showSortError = true;
        if ($event) {
          $event.stopPropagation();
        }
      }
    } else {
      $scope.sortByCallback($scope.sortCriteria);
    }
  };
  $scope.cancelSort = function () {
    if ($scope.sortCriteria.hashCode() !== $scope._lastSortCriteria.hashCode()) {
      $scope.resetSortCriteriaTo($scope._lastSortCriteria);
    }
  };
  $scope.adjustSortOptions = function () {
    $scope.sortOptionsIdx = 0;
  };
  $scope.initializeSortOptions = function () {
    function f() {
      $scope.sortOptions.length = 0;
      $scope.sortOptionsIdx = 0;
      $scope.sortCriteria.getSortColumns().forEach(function () {
        $scope.sortOptions.push(new SortColumnOptions($scope.columns));
      });
    }
    f();
    $scope.adjustSortOptions();
    return f;
  }();
  this.fireAdjustSortOptions = function () {
    $scope.adjustSortOptions();
    $scope.$broadcast('grid:sortOptionsAdjusted');
  };
  this.getSortColumnOptions = function () {
    if ($scope.sortOptionsIdx < $scope.sortOptions.length) {
      return $scope.sortOptions[$scope.sortOptionsIdx++];
    }
  };
  this.getSortColumn = function () {
    if ($scope.sortCriteria.hasNext()) {
      return $scope.sortCriteria.next();
    }
  };
};
SortCustomizationController.$inject = ['$scope', 'SortColumnOptionsFactory', 'SortCriteriaFactory'];
module.exports = SortCustomizationController;